import { IDropDownItem } from "../../services/generated";

export enum Module {
	Authorization = 'authorization',
	WorkQueues = 'workqueue',
	PreRegistration = 'pre-registration',
    Maintenance = 'maintenance',  
}

// workqueue 
export enum WorkqueueRefMapping {
	FollowUpWorkQueue = 15,
	PreRegWorkQueue = 25,
    EPTACAuthWorkQueue = 26,
    ExhaustedEffortWorkQueue = 9
}

export const WorkqueueDateRanges: Array<IDropDownItem> = [
    {label: 'Last 45 Days', value: '45'},
    {label: 'Last 90 Days', value: '90'},
    {label: 'Last 180 Days', value: '180'},
    {label: 'Last 1 Year', value: '365'},
    {label: 'Custom', value: 'custom'}
]

export const WorkQueueStatusesByDefault = ['IN PROGRESS', 'NOT STARTED'];

//Account
export const AccountStatusTypes: Array<IDropDownItem> = [
    {label: 'NOT STARTED', value: 'N'},
    {label: 'IN PROGRESS', value: 'I'},
    {label: 'COMPLETE', value: 'C'}
];

export enum ScheduleStatus {
    UNDEFINED = 'Undefined',
    PENDING = 'Pending',
    BOOKED = 'Booked',
    CANCELLED = 'Cancelled',
    ATTENDED = 'Attended',
    NOSHOW = 'No Show',
    REBOOK = 'Rebook'
}

export enum EMRSystem {
    MAGIC = 'Magic',
    EXPANSE = 'Expanse',
    EPIC = 'Epic',
    CERNER = 'Cerner'
}

// pre registration
export const PreRegCampaignTypes: Array<IDropDownItem> = [
    {label: 'Cash Campaign', value: '6'},
    {label: 'PreReg Campaign', value: '7'}
]

// Maintenance
export const ApptExclusionTypes: Array<IDropDownItem> = [
    {label: 'Appt. Location', value: 'Location'},
    {label: 'Appt. Type', value: 'Type'}
]

export const ContactListCampaignTypes: Array<IDropDownItem> = [
    {label: 'Agent', value: 'Agent'},
    {label: 'AgentLess', value: 'AgentLess'}
]
